import * as React from "react";
import { RootState } from "../../reducers/index";
import { useAppSelector } from "../../store/index";

const CheckoutClientHead = () => {
    const { clientName } = useAppSelector((state: RootState) => state.checkout);
    return (
        <>
            <h3>Client</h3>
            <p>{clientName}</p>
        </>
    );
};

export default CheckoutClientHead;
